import { RadioIcon as PhosphorRadioIcon } from "@phosphor-icons/react/dist/ssr/Radio";

import { createAppIcon } from "@/components/createAppIcon";

export const RadioIcon = /* @__PURE__ */ createAppIcon(PhosphorRadioIcon);
